<ng-container *transloco="let t; read: 'settings'">
<h2 class="mbm">{{ t('departments') }}</h2>
<kendo-grid
  [data]="departements"
  (edit)="editHandler($event)"
  (cancel)="cancelHandler($event)"
  (save)="saveHandler($event)"
  (remove)="removeHandler($event)"
  (add)="addHandler($event)"
  [style.maxHeight.px]="600"
>
  <ng-template kendoGridToolbarTemplate>
    <button
      *permissionIf="'Permissions.Departments.Create'"
      kendoGridAddCommand>{{ t('add') }}</button>
  </ng-template>
  <kendo-grid-column field="name" [title]="t('name')">
    <ng-template kendoGridEditTemplate let-formGroup="formGroup">
      <kendo-formfield>
        <kendo-textbox [formControl]="formGroup.get('name')"></kendo-textbox>
        <kendo-formerror *ngIf="formGroup.get('name').hasError('required') || formGroup.get('name').hasError('pattern')">{{ t('isRequiredField') }}</kendo-formerror>
        <kendo-formerror *ngIf="formGroup.get('name').hasError('maxlength')">{{ t('nameTooLong', { max: 75 }) }}</kendo-formerror>
        <kendo-formerror *ngIf="formGroup.get('name').hasError('isNotUnique')">{{ t('nameMustBeUnique') }}</kendo-formerror>
      </kendo-formfield>
    </ng-template>
  </kendo-grid-column>
  <kendo-grid-column field="schedulerColor" [title]="t('color')">
    <ng-template kendoGridCellTemplate let-dataItem>
      <kendo-colorpicker
        [value]="dataItem.schedulerColor"
        disabled="true"
      >
      </kendo-colorpicker>
    </ng-template>
    <ng-template
      kendoGridEditTemplate
      let-dataItem="dataItem"
      let-column="column"
      let-formGroup="formGroup"
    >
      <kendo-colorpicker
        [value]="dataItem.schedulerColor"
        [formControl]="formGroup.get('schedulerColor')"
        format="hex"
      >
      </kendo-colorpicker>
    </ng-template>
  </kendo-grid-column>
  <kendo-grid-command-column
    [title]="t('action')"
  >
    <ng-template kendoGridCellTemplate let-isNew="isNew">
      <button 
        *permissionIf="'Permissions.Departments.Update'"
        kendoGridEditCommand themeColor="primary">{{ t('edit') }}</button>
      <button 
        *permissionIf="'Permissions.Departments.Delete'"
        kendoGridRemoveCommand>{{ t('remove') }}</button>
      <button kendoGridSaveCommand [disabled]="formGroup?.invalid">
        {{ isNew ? t('add') : t('save') }}
      </button>
      <button kendoGridCancelCommand>
        {{ isNew ? t('discard') : t('cancel') }}
      </button>
    </ng-template>
  </kendo-grid-command-column>
</kendo-grid>

<app-delete-confirm-dialog
  [(opened)]="deletionDialogOpened"
  [message]="t('deletionMessages.department')"
  (confirmed)="deleteConfirmed()"
></app-delete-confirm-dialog>
</ng-container>
